export const pageDict = {
  en: {
    // Common
    "Filter": "Filter",
    "Create": "Create",
    "Export": "Export",
    "Clear Filter": "Clear Filter",
    "No data is available": "No data is available",
    "Enter...": "Enter...",
    "--Choose--": "--Choose--",
    "Start Date": "Start Date",
    "End Date": "End Date",
    "Delete": "Delete",
    "Close": "Close",
    "Upload": "Upload",
    "Add": "Add",
    "Update": "Update",
    "S.No": "S.No",
    "Name": "Name",
    "Status": "Status",
    "CreatedAt": "CreatedAt",
    "UpdatedAt": "UpdatedAt",
    "Action": "Action",
    "Actions": "Actions",
    "Description": "Description",
    "Country": "Country",
    "Email": "Email",
    "State": "State",
    "City": "City",
    "Just Updated": "Just Updated",
    "Download": "Download",
    "select date": "select date",

    // Dashboard Survey page
    "Dashboard": "Dashboard",
    "Survey Details": "Survey Details",
    "PM Name": "PM Name",
    "Type": "Type",
    "Project Name": "Project Name",
    "Project ID": "Project ID",
    "Project Id": "Project Id",
    "Client Name": "Client Name",
    "Survey Unique Id": "Survey Unique Id",
    "Filter Surveys": "Filter Surveys",
    "Client": "Client",
    "Complete": "Complete",
    "Terminate": "Terminate",
    "Quotafull": "Quotafull",
    "Quality Terminate": "Quality Terminate",
    "Hits": "Hits",
    "Dropouts%": "Dropouts%",
    "IR %": "IR %",
    "Median LOI": "Median LOI",
    "PM": "PM",

    // Survey type statuses
    "Live": "Live",
    "On Hold": "On Hold",
    "Ids Awaited": "Ids Awaited",
    "Ids awaited": "Ids awaited",
    "End": "End",
    "Test": "Test",

    // Surveys page
    "Surveys": "Surveys",
    "Complete Points": "Complete Points",

    // Samples page
    "Samples": "Samples",
    "Upload file": "Upload file",
    "Unique ID": "Unique ID",
    "Profile Count": "Profile Count",
    "Active": "Active",
    "Yes": "Yes",
    "No": "No",
    "Add Unique Sample": "Add Unique Sample",
    "Update Unique Sample": "Update Unique Sample",
    "Sample Name": "Sample Name",
    "Sample Description": "Sample Description",
    "File userId": "File userId",
    "File selected Name:": "File selected Name:",
    "Filter Samples": "Filter Samples",

    // Clients page
    "Clients": "Clients",
    "Company Name": "Company Name",
    "Contact Name": "Contact Name",
    "Number": "Number",
    "Zip Code": "Zip Code",
    "Are you sure want to delete this client?": "Are you sure want to delete this client?",

    // Partners page
    "Partners": "Partners",
    "Add partner passback variable": "Add partner passback variable",
    "Completed URL": "Completed URL",
    "Quota Full URL": "Quota Full URL",
    "Partner Passback Variable": "Partner Passback Variable",
    "Enter here": "Enter here",
    "Add Partner Passback Variable": "Add Partner Passback Variable",
    "Are you sure you want to delete this partner? This action cannot be undone.": "Are you sure you want to delete this partner? This action cannot be undone.",

    // Admin Dashboard / Reports
    "Reports": "Reports",
    "Select Partner": "Select Partner",
    "Select Survey": "Select Survey",
    "Download Report": "Download Report",
  },
  hi: {
    // Common
    "Filter": "फ़िल्टर",
    "Create": "बनाएं",
    "Export": "निर्यात",
    "Clear Filter": "फ़िल्टर साफ़ करें",
    "No data is available": "कोई डेटा उपलब्ध नहीं है",
    "Enter...": "दर्ज करें...",
    "--Choose--": "--चुनें--",
    "Start Date": "आरंभ तिथि",
    "End Date": "अंतिम तिथि",
    "Delete": "हटाएं",
    "Close": "बंद करें",
    "Upload": "अपलोड",
    "Add": "जोड़ें",
    "Update": "अपडेट",
    "S.No": "क्र.सं.",
    "Name": "नाम",
    "Status": "स्थिति",
    "CreatedAt": "बनाने की तारीख",
    "UpdatedAt": "अपडेट की तारीख",
    "Action": "कार्रवाई",
    "Actions": "कार्रवाई",
    "Description": "विवरण",
    "Country": "देश",
    "Email": "ईमेल",
    "State": "राज्य",
    "City": "शहर",
    "Just Updated": "अभी अपडेट किया",
    "Download": "डाउनलोड",
    "select date": "तारीख चुनें",

    // Dashboard Survey page
    "Dashboard": "डैशबोर्ड",
    "Survey Details": "सर्वे विवरण",
    "PM Name": "पीएम का नाम",
    "Type": "प्रकार",
    "Project Name": "परियोजना का नाम",
    "Project ID": "परियोजना आईडी",
    "Project Id": "परियोजना आईडी",
    "Client Name": "ग्राहक का नाम",
    "Survey Unique Id": "सर्वे यूनिक आईडी",
    "Filter Surveys": "सर्वे फ़िल्टर करें",
    "Client": "ग्राहक",
    "Complete": "पूर्ण",
    "Terminate": "समाप्त",
    "Quotafull": "कोटा पूरा",
    "Quality Terminate": "गुणवत्ता समाप्ति",
    "Hits": "हिट्स",
    "Dropouts%": "ड्रॉपआउट%",
    "IR %": "आईआर %",
    "Median LOI": "मीडियन एलओआई",
    "PM": "पीएम",

    // Survey type statuses
    "Live": "लाइव",
    "On Hold": "रुका हुआ",
    "Ids Awaited": "आईडी की प्रतीक्षा",
    "Ids awaited": "आईडी की प्रतीक्षा",
    "End": "समाप्त",
    "Test": "परीक्षण",

    // Surveys page
    "Surveys": "सर्वे",
    "Complete Points": "पूर्ण अंक",

    // Samples page
    "Samples": "प्रतिरूप",
    "Upload file": "फ़ाइल अपलोड करें",
    "Unique ID": "यूनिक आईडी",
    "Profile Count": "प्रोफ़ाइल गणना",
    "Active": "सक्रिय",
    "Yes": "हां",
    "No": "नहीं",
    "Add Unique Sample": "यूनिक सैंपल जोड़ें",
    "Update Unique Sample": "यूनिक सैंपल अपडेट करें",
    "Sample Name": "सैंपल का नाम",
    "Sample Description": "सैंपल विवरण",
    "File userId": "फ़ाइल userId",
    "File selected Name:": "चयनित फ़ाइल का नाम:",
    "Filter Samples": "सैंपल फ़िल्टर करें",

    // Clients page
    "Clients": "ग्राहक",
    "Company Name": "कंपनी का नाम",
    "Contact Name": "संपर्क नाम",
    "Number": "नंबर",
    "Zip Code": "ज़िप कोड",
    "Are you sure want to delete this client?": "क्या आप वाकई इस ग्राहक को हटाना चाहते हैं?",

    // Partners page
    "Partners": "साथी",
    "Add partner passback variable": "साथी पासबैक वेरिएबल जोड़ें",
    "Completed URL": "पूर्ण URL",
    "Quota Full URL": "कोटा पूर्ण URL",
    "Partner Passback Variable": "साथी पासबैक वेरिएबल",
    "Enter here": "यहां दर्ज करें",
    "Add Partner Passback Variable": "साथी पासबैक वेरिएबल जोड़ें",
    "Are you sure you want to delete this partner? This action cannot be undone.": "क्या आप वाकई इस साथी को हटाना चाहते हैं? यह कार्रवाई पूर्ववत नहीं की जा सकती।",

    // Admin Dashboard / Reports
    "Reports": "रिपोर्ट",
    "Select Partner": "साथी चुनें",
    "Select Survey": "सर्वे चुनें",
    "Download Report": "रिपोर्ट डाउनलोड करें",
  }
};
